<div class="blotter-container">
  @if (columnDefs.length) {
  <ag-grid-angular
    class="ag-theme-balham-dark blotter-container__ag-grid"
    rowSelection="multiple"
    [enableRangeSelection]="true"
    [columnDefs]="$any(columnDefs)"
    [groupSelectsChildren]="true"
    [suppressRowClickSelection]="true"
    [rowData]="blotterState().rows"
    [sideBar]="sideBarDef"
    (selectionChanged)="onSelectionChanged()"
    (gridReady)="onGridReady($event)"
    (sortChanged)="gridStateChanged($event)"
    (columnResized)="gridStateChanged($event)"
    (columnVisible)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPivotChanged)="gridStateChanged($event)"
    (columnRowGroupChanged)="gridStateChanged($event)"
    (columnValueChanged)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPinned)="gridStateChanged($event)"
  >
  </ag-grid-angular>
  <ng-container *ngTemplateOutlet="blotterFooter" />
  } @else { No grid headers available }
</div>

<ng-template #blotterFooter>
  <div class="blotter-container__footer" [formGroup]="blotterForm">
    @if (blotterState().lastUpdatedAt) {
    <div class="blotter-container__footer__last-updated">
      Last updated: {{ lastUpdatedAtStr }}
    </div>
    }
    <div class="blotter-container__footer__date">
      From Date:
      <date-with-spinner-info
        formControlName="fromDate"
        class="from-date"
        (inputChange)="onDateChange()"
        [inputValidator]="['prettyDate']"
      ></date-with-spinner-info>
    </div>

    <button
      class="ui-button ui-button__footer ui-button--primary"
      [disabled]="
        !selectedTrades.length ||
        !currentUserRole() ||
        currentUserRole() === 'ProviderTrader'
      "
      (click)="openTrades()"
    >
      Open
    </button>

    <button
      class="ui-button ui-button__footer ui-button--primary"
      [disabled]="!blotterForm.valid"
      (click)="updateBlotterData()"
    >
      Update
    </button>

    <button
      class="ui-button ui-button__footer ui-button--primary"
      [disabled]="selectedTrades.length !== 1"
      (click)="requestRfqTimeline(selectedTrades[0].requestId)"
    >
      RFQ Timeline
    </button>
  </div>
</ng-template>
